export default __webpack_public_path__ + "static/NGSwv5HMAFg6IuGlBNMjxLsD8ahuQ2e8Smg-2719c4f0a0421cfcb38e912e6fcd898a.woff2";